import { Box, useMediaQuery } from "@mui/material";
import { Outlet } from "react-router-dom";
import Header from "./_header";
import { useState } from "react";
import theme from "themes/Theme";
import Footer from "./_footer";

const HomeLayout = () => {
  const [open, setOpen] = useState<boolean>(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const toggleDrawer = () => {
    setOpen((prev) => !prev);
  };
  return (
    <Box>
      <Header toggleDrawer={toggleDrawer} open={open} isMobile={isMobile} />
      <Outlet />
      <Footer isMobile={isMobile} />
    </Box>
  );
};
export default HomeLayout;
